import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    line: {
      width: '100%',
      height: 1,
      background: theme.palette.secondary.light,
      marginBottom: 32,
    },
  }
})
